<template>
  <TransitionRoot appear :show="qrcreate.history_modal" as="template">
    <Dialog
      as="div"
      @close="qrcreate.history_modal = false"
      class="relative z-50"
    >
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-3xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all"
            >
              <DialogTitle>
                <div class="flex justify-between items-center">
                  <div class="flex items-center justify-center gap-2">
                    <HistoryIcon size="20" />
                    <h3 class="text-lg font-medium text-gray-900">
                      Recently QrCodes
                    </h3>
                  </div>
                  <button
                    @click="qrcreate.history_modal = false"
                    class="flex items-center justify-center p-2"
                  >
                    <XIcon />
                  </button>
                </div>
              </DialogTitle>
              <div
                class="mt-6 flex items-center flex-col p-3 rounded-md bg-gray-100 gap-y-3 max-h-[420px] overflow-y-auto"
              >
                <template v-if="qrcodes.length">
                  <div
                    class="w-full p-2 bg-white flex xs:items-center xs:flex-row flex-col gap-2"
                    v-for="qrcode in qrcodes"
                  >
                    <div class="w-20 mr-4 flex-shrink-0">
                      <img :src="qrcode.image" :alt="'qrcodes-'+qrcode.type" />
                    </div>
                    <div
                      class="flex w-full sm:flex-row flex-col sm:items-center items-start"
                    >
                      <div class="flex flex-col h-full">
                        <div class="flex items-center">
                          <b class="capitalize text-base">{{ qrcode.type }}</b>
                          <span
                            class="truncate sm:max-w-xs max-w-[180px] ml-2 text-sm"
                            :title="qrcode.data.text"
                            v-if="qrcode.type == 'text'"
                            >- {{ qrcode.data.content }}
                          </span>
                          <span
                            class="truncate sm:max-w-xs max-w-[180px] ml-2 text-sm"
                            :title="qrcode.data.url"
                            v-if="qrcode.type == 'url'"
                            >- {{ qrcode.data.url }}
                          </span>
                        </div>
                        <div
                          class="flex items-center text-sm"
                          v-if="qrcode.created_at"
                        >
                          <span>Created at: </span>
                          <b>{{ momentFunc(qrcode.created_at) }}</b>
                        </div>
                      </div>
                      <div
                        class="flex items-center sm:ml-auto xs:text-sm text-xs xs:mt-0 mt-2"
                      >
                        <button
                          @click="downloadImage(qrcode)"
                          class="px-3 py-1 flex items-center justify-center gap-1 mr-2 text-success"
                        >
                          <DownloadIcon size="18" /> Download
                        </button>
                        
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="flex items-center justify-between flex-col p-6">
                    <nuxt-img
                      src="/Oops!-bro.png"
                      format="webp"
                      width="200"
                      class="mb-4"
                      alt="No recently created Qr Code"
                    />
                    <h4>No recently created Qr Code</h4>
                  </div>
                </template>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script lang="ts" setup>
import { useQrCreateStore } from "~~/stores/qrcreate";
import { XIcon, DownloadIcon, HistoryIcon } from "vue-tabler-icons";
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/vue";
import moment from "moment";
import { storeToRefs } from "pinia";

const qrcreate = useQrCreateStore();
const qrcodes = ref<Array<any>>([]);
onMounted(() => {
  nextTick(() => {
    GetRecentlyQrcodes();
  });
});
const GetRecentlyQrcodes = () => {
  qrcodes.value = useQrStyle().GetStacKSession();
};
const momentFunc = (date: any) => {
  return moment(date).fromNow();
};
const downloadImage = (qrcode: { image: string; type: string }) => {
  var a = document.createElement("a");
  a.href = qrcode.image;
  a.download = "qrgateway_" + qrcode.type+"_" + new Date().getTime() + ".png";
  a.click();
  a.remove();
};
// const removeQr = (qrcode: { base64: string; type: string; id: string }) => {
//   qrcodes.value = qrcodes.value.filter((item) => item.id != qrcode.id);
//   localStorage.setItem("__sessions_way", JSON.stringify(qrcodes.value));
// };
const { history_modal } = storeToRefs(qrcreate);
watch(history_modal, (v) => {
  if (v) {
    GetRecentlyQrcodes();
  }
});
</script>

<style></style>
